import Figure from '@atoms/Figure/Figure';
import TextMediaWrapper from '@molecules/TextMediaWrapper/TextMediaWrapper';
import { TextImageSection as Props } from '@type-declarations/sections';
import clsx from 'clsx';

import styles from './TextImageSection.module.scss';

function TextImageSection({
  title,
  subtitle,
  text,
  cta,
  backgroundColor,
  textLeft,
  image,
  imageAlt,
  modifier,
  keepAspectRatio,
}: Props) {
  return (
    <TextMediaWrapper
      title={title}
      subtitle={subtitle}
      text={text}
      cta={cta}
      textLeft={textLeft}
      backgroundColor={backgroundColor.color}
      modifier={modifier === 'inStore' ? 'inStore' : undefined}
    >
      <Figure
        image={image}
        alt={imageAlt}
        author={image.author}
        sizes="(min-width: 1024px) 608px, (min-width: 1280px) 640px"
        className={clsx(
          styles.figure,
          keepAspectRatio && styles.keepAspectRatio
        )}
        layout={keepAspectRatio ? 'responsive' : 'fill'}
        imageClassName={styles.image}
        quality={100}
      />
    </TextMediaWrapper>
  );
}

export default TextImageSection;
